import { Typography } from "@mui/material";
import { styles as mainStyles } from "../styles";

const WaitlistInfo = () => (
  <Typography sx={mainStyles.leftAlignedTypographyBody}>
    <b>Same Day Waitlist:</b> Waitlist placements are open from 6 AM to 6 PM
    and are valid for today only. If you do not receive a call for an
    available appointment by the end of the day, we encourage you to try
    booking your appointment tomorrow for the most up-to-date availability.
  </Typography>
);

export default WaitlistInfo;
